<template>
	<section
		ref="sectionRef"
		class="brand-philosophy"
		:aria-label="t(`${I18N_NS}.brandPhilosophy.ariaLabel`)"
	>
		<header class="brand-philosophy__header">
			<img
				class="brand-philosophy__decor"
				src="../../../pc/images/title-decor-left.png"
				alt=""
				aria-hidden="true"
			/>
			<h2 class="brand-philosophy__title">{{ t(`${I18N_NS}.brandPhilosophy.title`) }}</h2>
			<img
				class="brand-philosophy__decor"
				src="../../../pc/images/title-decor-right.png"
				alt=""
				aria-hidden="true"
			/>
		</header>

		<p class="brand-philosophy__subtitle">
			{{ t(`${I18N_NS}.brandPhilosophy.subtitle`) }}
		</p>

		<p class="brand-philosophy__desc">
			{{ t(`${I18N_NS}.brandPhilosophy.desc`) }}
		</p>
	</section>
</template>

<script setup>
import { nextTick, onMounted, ref } from "vue";
import { useI18n } from "~/composables/useI18n";
import { ABOUT_SECTION_ID, useAboutUsTracking } from "../../../composables/useAboutUsTracking";

const I18N_NS = "aboutUs";
const { t } = useI18n();
const { track, observeImpression } = useAboutUsTracking("mobile");
const sectionRef = ref(null);

onMounted(() => {
	nextTick(() => {
		observeImpression("about_brand_section_view", sectionRef, () => {
			track("about_brand_section_view", {
				section_id: ABOUT_SECTION_ID.BRAND_CONCEPT,
			});
		});
	});
});
</script>

<style lang="scss" scoped>
.brand-philosophy {
	padding: 44px 32px 56px;
	background: linear-gradient(0deg, #fffbf3 0%, #ffffff 100%), #fffdf9;

	&__header {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
		margin-bottom: 4px;
	}

	&__decor {
		width: 94px;
		height: 12px;
		object-fit: contain;
		flex-shrink: 0;
	}

	&__title {
		margin: 0;
		color: #333333;
		font-size: 34px;
		font-weight: 700;
		line-height: 48px;
		white-space: nowrap;
	}

	&__subtitle {
		margin: 0 0 30px;
		color: #333333;
		font-size: 24px;
		line-height: 34px;
		text-align: center;
	}

	&__desc {
		margin: 0;
		color: #505050;
		font-size: 24px;
		font-weight: 400;
		line-height: 30px;
		letter-spacing: 1px;
		text-align: justify;
	}
}
</style>
